import { render, staticRenderFns } from "./import-changes.vue?vue&type=template&id=06d87028&scoped=true"
import script from "./import-changes.vue?vue&type=script&lang=ts"
export * from "./import-changes.vue?vue&type=script&lang=ts"
import style0 from "./import-changes.vue?vue&type=style&index=0&id=06d87028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d87028",
  null
  
)

export default component.exports